(function(){
  function makeSvg(paths){
    var ns='http://www.w3.org/2000/svg';
    var svg=document.createElementNS(ns,'svg');
    svg.setAttribute('viewBox','0 0 64 64');
    svg.setAttribute('aria-hidden','true');
    var g=document.createElementNS(ns,'g');
    g.setAttribute('fill','none');
    g.setAttribute('stroke','currentColor');
    g.setAttribute('stroke-width','1.65');
    g.setAttribute('stroke-linecap','round');
    g.setAttribute('stroke-linejoin','round');
    svg.appendChild(g);
    paths.forEach(function(d){var p=document.createElementNS(ns,'path');p.setAttribute('d',d);g.appendChild(p);});
    return svg;
  }
  function css(){
    if(document.getElementById('plawny-home-polish-fixes-css')) return;
    var s=document.createElement('style');
    s.id='plawny-home-polish-fixes-css';
    s.textContent='body .pph2 h1,body .pph2-copy h1,body [data-hero-title]{line-height:1.08!important;letter-spacing:-.032em!important;word-spacing:.02em!important;text-wrap:balance!important;max-width:760px!important}body .pph2-copy{padding-top:clamp(70px,8vw,112px)!important;padding-bottom:clamp(70px,8vw,112px)!important}body .pph2-copy p{line-height:1.68!important;max-width:680px!important}body .pph2 span,body .pph2-head span{letter-spacing:.12em!important;line-height:1.35!important}.pph2-trust>div:before,.pph2-trust>div:after{display:none!important;content:none!important}.pph2-trust>div{display:grid!important;grid-template-columns:46px 1fr!important;grid-template-rows:auto auto!important;column-gap:15px!important;align-items:center!important;padding:21px 26px!important}.plawny-trust-icon{grid-row:1/3!important;width:38px!important;height:38px!important;border:1px solid rgba(227,189,121,.38)!important;border-radius:13px!important;background:rgba(227,189,121,.03)!important;color:#e3bd79!important;display:flex!important;align-items:center!important;justify-content:center!important}.plawny-trust-icon svg{width:25px!important;height:25px!important;display:block!important}.pph2-trust b{grid-column:2!important}.pph2-trust small{grid-column:2!important}@media(max-width:620px){body .pph2 h1,body .pph2-copy h1,body [data-hero-title]{font-size:clamp(40px,12.8vw,58px)!important;line-height:1.1!important;letter-spacing:-.018em!important;max-width:100%!important}.pph2-trust>div{grid-template-columns:42px 1fr!important;padding:18px!important}.plawny-trust-icon{width:35px!important;height:35px!important}.plawny-trust-icon svg{width:22px!important;height:22px!important}}';
    document.head.appendChild(s);
  }
  function fixOpinieLinks(){
    document.querySelectorAll('a[href]').forEach(function(a){
      var txt=(a.textContent||'').trim().toLowerCase();
      var href=(a.getAttribute('href')||'').toLowerCase();
      if(txt==='opinie'||txt.indexOf('opinie')!==-1||href.indexOf('judge')!==-1||href.indexOf('reviews')!==-1){
        if(txt.indexOf('opinie')!==-1 || href.indexOf('judge')!==-1){
          a.setAttribute('href','/pages/opinie');
          a.removeAttribute('target');
          a.removeAttribute('rel');
        }
      }
    });
  }
  function fixTrustIcons(){
    var items=document.querySelectorAll('.pph2-trust>div');
    if(!items.length) return;
    var icons=[
      ['M18 13c4-3 10-3 15-1 5-2 11-1 15 4-2 4-2 8 1 12-4 3-5 8-3 13-5 1-8 4-10 8-5-3-10-2-14 1-3-5-8-7-13-6 1-5-1-9-5-12 4-3 5-8 3-13 5-1 8-4 11-6Z','M22 24c8-3 17-2 25 3','M19 38c9 3 18 3 29-1','M27 31h.1M35 29h.1M42 34h.1'],
      ['M27 8l6 3 8-2 5 6-2 8 6 5-2 7 4 7-8 3-4 8-8-1-7 4-6-6-9-1 1-9-4-6 5-6-1-9 9-3 7-8Z','M23 23l8 5 9-4','M22 39l10-3 8 5'],
      ['M15 48h34','M18 39c9-9 18-18 29-28','M17 18c6 5 8 14 5 24','M31 12c5 9 5 20 0 30','M47 12c-1 12-6 22-15 30','M22 50l-5-5','M43 50l5-5'],
      ['M49 9c-18 3-31 14-34 31-1 8 4 14 12 13 17-3 28-16 31-34-4 2-7 3-9 4Z','M17 50c8-10 17-19 31-28','M27 40c-1-5 0-10 3-14','M36 31c3 1 7 1 11-1']
    ];
    for(var i=0;i<items.length;i++){
      var old=items[i].querySelector('.plawny-trust-icon'); if(old) old.remove();
      var sp=document.createElement('span'); sp.className='plawny-trust-icon'; sp.appendChild(makeSvg(icons[i]||icons[0]));
      items[i].insertBefore(sp,items[i].firstChild);
    }
  }
function fixHomeLogo(){
  var logo=document.querySelector('.plawny-product-hero__logo');
  if(!logo) return;
  if(logo.querySelector('img')) return;

  logo.classList.add('plawny-product-hero__logo--image');
  logo.textContent='';

  var img=document.createElement('img');
  img.src='https://cdn.shopify.com/s/files/1/0991/7379/4140/files/plawnyshoes-logo-original-blue.png?v=1781117724';
  img.alt='Pławny Shoes';
  img.loading='eager';

  logo.appendChild(img);
}

function run(){css();fixHomeLogo();fixOpinieLinks();fixTrustIcons();}  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  window.addEventListener('load',run);setTimeout(run,400);setTimeout(run,1200);setTimeout(run,2500);
})();